module.exports = __webpack_public_path__ + "static/WheelRotatingRange-facb045bc65e424b357ea6e4b934a3be.jpg";